import { 
  LOADING_REBATES, 
  FETCH_REBATES, 
  FETCH_REBATE,
  SET_FILTRO_REBATES
} from '../actions/types';

const initialState = {
  loadingRebates: false,
  rebates: {
    rebates: [],
    cantidadTotal: 0
  },
  rebate: {},
  filtro: {}
}

export default function (state = initialState, action) {

  switch (action.type) {

    case LOADING_REBATES:
      return {
        ...state,
        loadingRebates: action.payload
      };

    case SET_FILTRO_REBATES:
      return {
        ...state,
        filtro: action.payload
      };
      
    case FETCH_REBATES:
      return {
        ...state,
        rebates: action.payload
      };

    case FETCH_REBATE:
      return {
        ...state,
        rebate: action.payload
      };

    default:
      return state
  }
}